/**
 * Visits Left Trigger Component
 *
 * Trigger: "visits left threshold"
 * Shows: count input
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { FormTextField } from 'src/shared/Forms/Fields/FormTextField';

import { TriggerComponentProps } from '../automationTriggers';

export const VisitsLeftTrigger: FC<TriggerComponentProps> = ({
  automation,
  index,
  readOnly,
}) => {
  const { t } = useTranslation();
  const count = automation.count || 1;

  if (readOnly) {
    return <span>{t('automations.triggers.visitsLeftCount', { count })}</span>;
  }

  // Edit mode
  return (
    <Box sx={{ maxWidth: 150 }}>
      <FormTextField
        name={`automations.${index}.count`}
        label={t('automations.triggerLabels.threshold')}
        type="number"
        InputProps={{ inputProps: { min: 1 } }}
      />
    </Box>
  );
};
